export default "__VITE_ASSET__Cxafn5zq__"